import {API_ENDPOINT, AUTH_HEADERS} from "../../util/constants";
import {RSAA} from "redux-api-middleware";
import * as types from "../types/index";
import {handleUnauthorizedAccess} from "../../util/utility";

export function createTestBroadcast(token, api_token) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/test-broadcast?api_token=${api_token}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.CREATE_TEST_BROADCAST_REQUEST, types.CREATE_TEST_BROADCAST_RECEIVE, {
                type: types.CREATE_TEST_BROADCAST_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetCreateTestBroadcast = () => ({
    type: types.RESET_CREATE_TEST_BROADCAST,
    payload: null
});
